import React,{useState,useEffect} from "react";
import  Axios  from "axios";
import CryptoJS from "crypto-js";

let isAuthExpiredHandled = false;

const checkAuthExpired = (resData) => {
    const isExpired =
        resData?.data?.expired === true ||
        resData?.message === 'โทเคนหมดอายุ กรุณาเข้าสู่ระบบใหม่' ||
        resData?.message === 'โทเคนหมดอายุหรือไม่ได้รับอนุญาต';

    if (isExpired) {
        if (!isAuthExpiredHandled && typeof window !== 'undefined') {
            isAuthExpiredHandled = true;
            localStorage.removeItem('Token');
            window.dispatchEvent(new CustomEvent('auth:expired', { detail: { message: resData?.message || 'โทเคนหมดอายุ กรุณาเข้าสู่ระบบใหม่' } }));
            setTimeout(() => {
                isAuthExpiredHandled = false;
            }, 2000);
        }
    }
};

const AxiosPostData = async(API ,path,Data ,headers) => {
//  console.log(API ,path,Data ,headers);
    try{
        const response = await Axios.post(`${API}${path}`, Data ,{headers});
        checkAuthExpired(response.data);
        return response.data;
    }catch(err){
        // Network errors (ECONNREFUSED, timeout) have no response
        if (err.response) {
            checkAuthExpired(err.response.data, err.response.status);
            return err.response.data;
        }
        // Return a safe error object so callers don't crash
        return { status: 'error', message: err.message || 'Network error', data: null };
    }
}

export const AxiosInstance = async (API,pathData,Data ) => {

    const headers = { 
        "Content-Type": 'application/json',            
        "Authorization": `${localStorage.getItem('Token')}`,
        // "X-Client-Domain": 'https://eveebook.com',
    };

    try {
        const response = await Axios.post(`${API}${pathData}`, Data ,{headers});
        checkAuthExpired(response.data);
        return response.data;
    }catch(err){
        if (err.response) {
            checkAuthExpired(err.response.data);
            return err.response.data;
        }
        return { status: 'error', message: err.message || 'Network error', data: null };
    }
}


const AxiosGetData = async(API,pathData ,headers,privateKey) => {

    try{
        const response = await Axios.get(`${API}${pathData}`,{headers});
        // console.log(response.data);
        checkAuthExpired(response.data);
        
        let returndata ;
        if(response.data && response.data.data !== undefined){
            try {
                if (privateKey && typeof response.data.data === 'string') {
                    const decryptedData = CryptoJS.AES.decrypt(response.data.data, privateKey).toString(CryptoJS.enc.Utf8);
                    if(decryptedData){
                        returndata = JSON.parse(decryptedData)
                    }else{
                        returndata = response.data.data
                    }
                } else {
                    returndata = response.data.data
                }
            } catch (error) {
                returndata = response.data.data;
            }
            return returndata;
        }else{
          return response.data
        }
        
        
    }catch(err){
        console.log(err);
        if (err.response) {
            checkAuthExpired(err.response.data);
            return err.response.data;
        }
        return { status: 'error', message: err.message || 'Network error', data: null };
    }
}

const AxiosPutData = async(API ,path,Data ,headers) => {

    try{
        const response = await Axios.put(`${API}${path}`, Data,{headers});
        checkAuthExpired(response.data);
        return response.data;
    }catch(err){
        if (err.response) {
            checkAuthExpired(err.response.data);
            return err.response.data;
        }
        return { status: 'error', message: err.message || 'Network error', data: null };
    }
} 

const AxiosDeleteData = async(API,path,key,headers) => {

    try{
        const response = await Axios.delete(`${API}/api/${path}/${key}`,{headers});
        checkAuthExpired(response.data);
        return response.data;
    }catch(err){
        if (err.response) {
            checkAuthExpired(err.response.data);
            return err.response.data;
        }
        return { status: 'error', message: err.message || 'Network error', data: null };
    }
}



export {AxiosPostData,AxiosGetData,AxiosPutData,AxiosDeleteData};